import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "coin-select-item__left" }
const _hoisted_2 = { class: "coin-select-item__title coin-select-item__title--left" }
const _hoisted_3 = {
  key: 0,
  class: "coin-select-item__description coin-select-item__description--left"
}
const _hoisted_4 = {
  key: 0,
  class: "coin-select-item__right"
}

import { computed, ref, type PropType } from 'vue';
import { inject } from 'vue';

import BigNumber from '@exchange/helpers/bignumber';
import { type ModalVariant } from '@exchange/libs/modals/src';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { CurrencyModel } from '@exchange/libs/utils/currency/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'CoinSelectItem',
  props: {
  balance: { type: Object as PropType<BigNumber>, required: true },
  currency: { type: Object as PropType<CurrencyModel>, required: true },
  isSelected: { type: Boolean, default: false },
  isWithdraw: { type: Boolean, required: true },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {

const props = __props;

const eurValue = computed(() => (props.balance ? props.balance.times(props.currency.defaultFiatValue) : 0));
const disabled = computed(() => props.isWithdraw && props.balance.isEqualTo(0));
const coinDescription = computed(() => props.currency.getCurrencyName());
const defaultPrecision = {
  fiat: CONSTANTS.PRECISION.DEFAULT_FIAT,
};
const balanceMasked = inject('balanceMasked', ref(false));

return (_ctx: any,_cache: any) => {
  const _component_x_logo = _resolveComponent("x-logo")!
  const _component_ot_balance = _resolveComponent("ot-balance")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['coin-select-item', `coin-select-item--${__props.variant}`, { 'coin-select-item--selected': __props.isSelected, 'coin-select-item--disabled': disabled.value }])
  }, [
    _createVNode(_component_x_logo, {
      class: "coin-select-item__logo",
      name: __props.currency.id,
      type: "crypto"
    }, null, 8, ["name"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.currency.id), 1),
      (coinDescription.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(coinDescription.value), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.isWithdraw)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ot_balance, {
            class: "coin-select-item__title",
            value: __props.balance,
            precision: __props.currency.precision,
            masked: _unref(balanceMasked)
          }, null, 8, ["value", "precision", "masked"]),
          _createVNode(_component_ot_balance, {
            class: "coin-select-item__description",
            value: eurValue.value,
            precision: defaultPrecision.fiat,
            masked: _unref(balanceMasked)
          }, null, 8, ["value", "precision", "masked"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})